import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface StatProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  className?: string;
  mono?: boolean;
}

export function Stat({ label, value, hint, className, mono = false }: StatProps) {
  return (
    <div
      className={cn(
        "rounded-lg border border-[var(--color-border-subtle)] bg-[rgba(255,255,255,0.02)] p-4",
        className
      )}
    >
      <div className="text-[11px] font-medium uppercase tracking-wider text-[var(--color-fg-subtle)]">
        {label}
      </div>
      <div
        className={cn(
          "mt-1.5 text-2xl font-semibold tracking-[-0.4px] text-[var(--color-fg)]",
          mono && "font-mono text-xl"
        )}
      >
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-[var(--color-fg-subtle)]">{hint}</div>}
    </div>
  );
}
